var ThemeType = {
  Dark: "dark",
  Light: "light",
  Video: "video"
};

export default ThemeType;
